import { registerTheme } from 'echarts/core'

import { CHART, resolveChartColors } from '@/components/charts/chartPalette'

const CHART_THEME = 'balto'

const axis = {
  axisLine: { lineStyle: { color: CHART.BORDER } },
  axisTick: { lineStyle: { color: CHART.BORDER } },
  axisLabel: { color: CHART.TEXT_MUTED },
  nameTextStyle: { color: CHART.TEXT_MUTED },
  splitLine: { lineStyle: { color: CHART.BORDER } },
  splitArea: { areaStyle: { color: [CHART.HOVER_OVERLAY, 'transparent'] } },
}

// Token references resolved once per theme when it is registered. Tooltips are
// DOM nodes and could use var() directly, but they are kept here so the theme is complete.
const chartTheme = (theme) => ({
  color: [
    CHART.BRAND,
    CHART.SUCCESS,
    CHART.WARNING,
    CHART.CAUTION,
    CHART.INFORMATIVE,
    CHART.MAGICAL,
    CHART.CRITICAL,
  ],
  backgroundColor: 'transparent',
  // Lets ECharts pick light text for labels drawn outside their host in dark mode.
  darkMode: theme === 'dark',
  textStyle: { color: CHART.TEXT_SECONDARY },
  title: { textStyle: { color: CHART.TEXT }, subtextStyle: { color: CHART.TEXT_MUTED } },
  legend: {
    textStyle: { color: CHART.TEXT_SECONDARY },
    pageTextStyle: { color: CHART.TEXT_SECONDARY },
  },
  tooltip: {
    backgroundColor: CHART.SURFACE,
    borderColor: CHART.BORDER,
    textStyle: { color: CHART.TEXT },
  },
  categoryAxis: axis,
  valueAxis: axis,
  timeAxis: axis,
  logAxis: axis,
  radar: {
    axisName: { color: CHART.TEXT_MUTED },
    axisLine: { lineStyle: { color: CHART.BORDER } },
    splitLine: { lineStyle: { color: CHART.BORDER } },
    splitArea: { areaStyle: { color: [CHART.HOVER_OVERLAY, 'transparent'] } },
  },
  bar: { label: { color: CHART.TEXT, textBorderWidth: 0 } },
  line: { label: { color: CHART.TEXT, textBorderWidth: 0 } },
  scatter: { label: { color: CHART.TEXT, textBorderWidth: 0 } },
  visualMap: { textStyle: { color: CHART.TEXT_SECONDARY } },
})

const registered = {}

// Registers the resolved theme for the active light/dark value once and returns
// its name; charts pass the name to init.
export const ensureChartTheme = (theme) => {
  const name = `${CHART_THEME}-${theme}`
  if (!registered[name]) {
    registerTheme(name, resolveChartColors(chartTheme(theme)))
    registered[name] = true
  }
  return name
}
